import { useEffect as e, useState as t } from "react";
//#region src/hooks/use-timeout.ts
var n = (n, r = !0) => {
	let [i, a] = t(!1);
	return e(() => {
		if (!r || n === void 0) {
			a(!1);
			return;
		}
		let e = setTimeout(() => a(!0), n);
		return () => clearTimeout(e);
	}, [r, n]), i;
};
//#endregion
export { n as useTimeout };
